import { render, staticRenderFns } from "./RoleContextMenu.vue?vue&type=template&id=9f8be6ea&scoped=true&"
import script from "./RoleContextMenu.vue?vue&type=script&lang=js&"
export * from "./RoleContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./RoleContextMenu.vue?vue&type=style&index=0&id=9f8be6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8be6ea",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/RoleTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Froles%2FRoleContextMenu.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports